import React from "react";
import { PieChart, Pie, Cell, Legend } from "recharts";

const data = [
  { name: "S", value: 400 },
  { name: "W", value: 300 },
  { name: "O", value: 300 },
  { name: "T", value: 200 }
];

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

export default function App() {
  return (
    <PieChart width={150} height={210}>
      <Pie
        data={data}
        cx={70}
        cy={90}
        labelLine={false}
        outerRadius={70}
        fill="#8884d8"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Legend verticalAlign="bottom" iconType={"circle"} iconSize={8}/>     {/*下面那四個點 s,w,o,t */}
    </PieChart>
  );
}
